import { put } from "redux-saga/effects";
import { FieldsService } from "../../../services/fields";

import { updateMarkerFailure, updateMarkerSuccess } from "../actionCreaters";

import { markersResponse, UpdateMarkerRequestActionType } from "../types";

export function* updateMarkerSaga({ payload: { fieldId, markerId, markerData } }: UpdateMarkerRequestActionType) {
    try {
        const {
            data: { data },
        }: markersResponse = yield FieldsService.updateMarker(fieldId, markerId, markerData);

        yield put(updateMarkerSuccess({ fieldId, markers: data.markers }));
    } catch (error) {
        yield put(updateMarkerFailure({ fieldId: fieldId }));
        // yield put(Handle Error);
    }
}
